import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";

import axios from "axios";
import { useAppContext } from "../../AppContext"; // Adjust the path as needed
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import "ag-grid-enterprise";
import AdminAdTopSectionUpdate from "./AdminAdTopSectionUpdate";
import { MyDomain } from "../../App";
export default function AdminAdTopSectionGet() {
  //for AdminAdTopSectionUpdate comp
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen((prev) => !prev);
  };
  //for update from AdminAdTopSectionUpdate
  const handleUpdateItem = (updatedItem) => {
    setData((prevItems) =>
      prevItems.map((item) => (item.id === updatedItem.id ? updatedItem : item))
    );
  };
  //end for update from AdminAdTopSectionUpdate

  //end for AdminAdTopSectionUpdate comp

  const [Data, setData] = useState([]);
  const gridRef = useRef(); // Optional - for accessing Grid's API

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  const { User, Token } = useAppContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = async () => {
    console.log("aa");
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(
        `${MyDomain}AdTopSection/GetAllAdTopSection`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          //params: { Id: User.userId },
        }
      );
      setData(response.data);
      console.log(response.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setError(err.response.data.error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [OneAdTopSection, setOneAdTopSection] = useState("");

  const BtnCellRenderer = (rowData) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <button
          style={{
            //marginTop: 20,
            backgroundColor: "#27272a",
            color: "#fff",
            border: "none",
            //padding: "10px 20px",
            cursor: "pointer",
            fontSize: "16px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 50,
          }}
          onClick={() => {
            toggleOpen();
            setOneAdTopSection(rowData.data);
            console.log(rowData.data);
          }}
        >
          {/* {rowData.data.order.id} */}
          <a>UPDATE</a>
        </button>
      </div>
    );
  };
  const [columnDefs, setColumnDefs] = useState([
    {
      minWidth: 80,
      flex: width > 766 ? 1 : null,
      field: "id",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",
      valueFormatter: (params) => `${params.value}`,
    },
    {
      minWidth: MyWidth >= 1024 ? 100 : 50,
      width: 100,
      flex: MyWidth > 766 ? 1 : null,
      headerName: "Actions",
      headerClass: "my-header-class",
      field: "Action",
      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        clicked: function (field) {
          alert(`${field} was clicked`);
        },
      },
    },
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "codeCat",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",
      valueFormatter: (params) => `${params.value}`,
    },
    {
      flex: width > 766 ? 1 : null,
      field: "image",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "dateStart",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "dateEnd",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "linkToTake",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "howManyClicked",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "whichPlaceInCarousel",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "itsRun",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "newsCodeCat",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
  ]);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === Data.length ? "bottom-row" : "";
    },
    // other grid options...
  };
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    // "rag-amber-outer": function (params) {
    //   return params.value === 2004;
    // },
    // "rag-red-outer": function (params) {
    //   return params.value === 2000;
    // },
  };
  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true, // Add this line to enable resizing
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  return (
    <div>
      <AdminAdTopSectionUpdate
        OneAdTopSection={OneAdTopSection}
        open={open}
        setOpen={setOpen}
        onUpdate={handleUpdateItem}
      />
      <div style={{ paddingTop: 30 }}>
        <div style={containerStyle}>
          <div style={gridStyle} className="ag-theme-alpine">
            <span style={{ color: "#1a1523", fontSize: 18 }}>
              Ad top section
              {/* <span style={{ color: "#e4e2e4" }}> • </span>{" "}
              <span style={{ color: "#6f6e77" }}>{startDate}</span> */}
            </span>
            <AgGridReact
              cellClassRules={ragCellClassRules}
              ref={gridRef} // Ref for accessing Grid's API
              rowData={Data} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              rowSelection="multiple" // Options - allows click selection of rows
              onCellClicked={cellClickedListener} // Optional - registering for Grid Event
              onGridReady={onGridReady}
              gridOptions={gridOptions}
              suppressScrollOnNewData={true}
              getRowHeight={getRowHeight}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={10}
            />
          </div>
        </div>
        <style>
          {`
             .ag-theme-alpine .ag-root-wrapper {
               border: none;
             }
            `}
          {`
              .my-header-class {
                background-color: white;
              }
            `}
        </style>
      </div>
    </div>
  );
}
